import { createFileRoute } from '@tanstack/react-router';
import CreateCountry from '../../../features/baseData/countries/country/create';
import {
  COUNTRIES_PERMISSIONS,
  createPermissionGuard,
  getPermissionSet,
} from '@bmwe/ui';

export const Route = createFileRoute('/stammdaten/laender/neu')({
  component: CreateCountry,
  beforeLoad: createPermissionGuard(
    getPermissionSet(COUNTRIES_PERMISSIONS, 'EDIT'),
  ),
});

export const CreateCountryRoute = Route;
